import { defineComponent as _defineComponent } from 'vue'
import { onMounted, computed, ref } from 'vue';
import { defineMessages } from '@/lib/i18n';
import { store } from '@/store/index';
import { dispatchLogOut, dispatchInit } from '@/store/main/actionsMain';
import { readUserLocale, readInitialized } from '@/store/main/getters';
import BaseNotificationsManager from '@/views/base/BaseNotificationsManager.vue';
import ConfirmDialog from '@/components/common/ConfirmDialog.vue';
import { i18n } from '@/plugins/vue-i18n';
import BaseLanguageSetting from './views/base/BaseLanguageSetting.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  loading: '読み込み中...',
});

const initialized = computed(() => readInitialized(store));
const initialTimeoutPassed = ref(false);

onMounted(function () {
  dispatchInit(store);
  // Delaying initial spinner and notification rendering to avoid flickering when the app is loading quickly.
  setTimeout(() => {
    initialTimeoutPassed.value = true;
  }, 500);
});

const locale = computed(() => readUserLocale(store));

const logout = async (): Promise<void> => {
  await dispatchLogOut(store);
};

return { __sfc: true,$t, m, initialized, initialTimeoutPassed, locale, logout, BaseNotificationsManager, ConfirmDialog, BaseLanguageSetting }
}

})